import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';

export function useCurrency(): (value: number) => string {
	const { data: siteSettings } = useGetPublicInformationQuery();
	// Eventually we'll get this from site settings
	const lang = siteSettings?.language || 'en-US';
	const currency = siteSettings?.currency || 'USD';

	const format = Intl.NumberFormat(lang, { currency, style: 'currency' });
	return format.format;
}
